export const CREATE_COLLEGE_COUNSELLING_DESTINATION = 'CREATE_COLLEGE_COUNSELLING_DESTINATION'
export const DELETE_COLLEGE_COUNSELLING_DESTINATION = 'DELETE_COLLEGE_COUNSELLING_DESTINATION'
export const GET_COLLEGE_COUNSELLING_DESTINATIONS = 'GET_COLLEGE_COUNSELLING_DESTINATIONS'
export const UPDATE_COLLEGE_COUNSELLING_DESTINATION = 'UPDATE_COLLEGE_COUNSELLING_DESTINATION'
